export default __webpack_public_path__ + "c914a08f4324fbf9cd3d5cb978720a82.png";